import { useEffect, useState } from "react";
import { fetchSmsSenderFor } from "../api/communicationsApi";

export const COLLINGS_SENDER = { own_number: false, sender: "COLLINGS", intro: "" };
const COLLINGS = COLLINGS_SENDER;

/**
 * Which number a text sent as `agentId` (blank = the logged-in user) goes out
 * from, and the opening line it must start with when that is the agent's own
 * mobile (Simon Abbott, Monday 13392775822, 30 Oct 2026: "it is now law that
 * the text starts with "Hi, it's (agents name) from Collings Real Estate"").
 *
 * Only for showing and pricing the line: the backend adds it at send time
 * whatever this says, so a failed lookup just reads as COLLINGS.
 */
export default function useSmsSender(agentId, enabled = true) {
  const [info, setInfo] = useState(COLLINGS);
  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    // Called inside the promise so a lookup that throws outright lands in the
    // catch too, instead of taking the composer down with it.
    Promise.resolve()
      .then(() => fetchSmsSenderFor(agentId || null))
      .then((res) => { if (live) setInfo({ ...COLLINGS, ...(res || {}) }); })
      .catch(() => { if (live) setInfo(COLLINGS); });
    return () => { live = false; };
  }, [agentId, enabled]);
  return info;
}
